import React, { useState } from 'react';
import { FiPhone, FiMessageCircle } from 'react-icons/fi';

// Renders a phone number that, when tapped, offers Call (tel:) and WhatsApp (wa.me).
// `whatsapp` falls back to `phone` when not provided.
const PhoneLink = ({ phone, whatsapp, style }) => {
  const [open, setOpen] = useState(false);
  if (!phone && !whatsapp) return <span style={{ color: '#9ca3af' }}>—</span>;

  const display = phone || whatsapp;
  const callNumber = phone || whatsapp;
  const waDigits = String(whatsapp || phone).replace(/[^\d]/g, '');

  const close = () => setOpen(false);
  const act = (e, href) => {
    e.stopPropagation();
    close();
    window.open(href, href.startsWith('tel:') ? '_self' : '_blank');
  };

  return (
    <span style={{ position: 'relative', display: 'inline-block' }} onClick={e => e.stopPropagation()}>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        style={{ background: 'none', border: 'none', padding: 0, margin: 0, color: '#2563eb', cursor: 'pointer', fontWeight: 600, fontSize: 'inherit', fontFamily: 'inherit', ...style }}
      >
        {display}
      </button>
      {open && (
        <>
          <div onClick={close} style={{ position: 'fixed', inset: 0, zIndex: 998 }} />
          <div style={{ position: 'absolute', top: '100%', left: 0, marginTop: 4, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, boxShadow: '0 8px 24px rgba(0,0,0,0.16)', zIndex: 999, minWidth: 150, overflow: 'hidden' }}>
            <button type="button" onClick={e => act(e, `tel:${callNumber}`)}
              style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '10px 14px', background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, color: '#111827', textAlign: 'left' }}
              onMouseEnter={e => e.currentTarget.style.background = '#f3f4f6'}
              onMouseLeave={e => e.currentTarget.style.background = 'none'}>
              <FiPhone style={{ color: '#2563eb' }} /> Call
            </button>
            <button type="button" onClick={e => act(e, `https://wa.me/${waDigits}`)}
              style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '10px 14px', background: 'none', border: 'none', borderTop: '1px solid #f3f4f6', cursor: 'pointer', fontSize: 13, color: '#111827', textAlign: 'left' }}
              onMouseEnter={e => e.currentTarget.style.background = '#f0fdf4'}
              onMouseLeave={e => e.currentTarget.style.background = 'none'}>
              <FiMessageCircle style={{ color: '#16a34a' }} /> WhatsApp
            </button>
          </div>
        </>
      )}
    </span>
  );
};

export default PhoneLink;
